import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><linearGradient id=\"i-975394937__a\" x1=\"0%\" x2=\"100%\" y1=\"0%\" y2=\"100%\"><stop offset=\"0%\" stop-color=\"#9900F1\"></stop><stop offset=\"100%\" stop-color=\"#9900F1\"></stop></linearGradient></defs><g fill=\"none\" fill-rule=\"evenodd\"><rect width=\"50\" height=\"50\" fill=\"url(#i-975394937__a)\" rx=\"8\"></rect><text fill=\"#FFF\" font-family=\"NeueHaasUnicaPro-Bold, Neue Haas Unica Pro\" font-size=\"20\" font-weight=\"bold\"><tspan x=\"8\" y=\"25\">1P</tspan></text></g>", 2)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "onepass-mobile-icon-logo"}) } }